
const config = { "family-regular": ["var(--font-family-regular)","var(--font-family-regular)"], "family-medium": ["var(--font-family-medium)","var(--font-family-medium)"],  }
export { config as default }